export default __webpack_public_path__ + "static/media/7e9c5e56bb0723e4cf6913212d991dc8.svg";